import { domainError, err, ok } from '@flourprint/core/domain';
const copy = (value) => JSON.parse(JSON.stringify(value));
/** In-memory personal equipment entries; same contract as the SQLite implementations. */
export class MemoryEquipmentRegistry {
    /** Versions of each id, in order: index i holds version i + 1. */
    #entries = new Map();
    async listEquipment() {
        return [...this.#entries.keys()]
            .sort()
            .flatMap((id) => this.#entries.get(id)?.slice(-1) ?? [])
            .map(copy);
    }
    async getEquipment(id, version) {
        const entry = this.#entries.get(id)?.[version - 1];
        return ok(entry && copy(entry));
    }
    async listEquipmentVersions() {
        return [...this.#entries.keys()]
            .sort()
            .flatMap((id) => (this.#entries.get(id) ?? []).map(copy));
    }
    async saveEquipment(entry) {
        const currentHead = this.#entries.get(entry.id)?.length ?? 0;
        if (entry.version !== currentHead + 1) {
            return err(domainError('HeadConflict', `Equipment ${entry.id} is at version ${currentHead}`, {
                equipmentId: entry.id,
                currentHead,
            }));
        }
        this.write(entry);
        return ok(copy(entry));
    }
    /** Writes a checked version synchronously (restores). */
    write(entry) {
        const versions = this.#entries.get(entry.id) ?? [];
        versions[entry.version - 1] = copy(entry);
        this.#entries.set(entry.id, versions);
    }
    get isEmpty() {
        return this.#entries.size === 0;
    }
}
//# sourceMappingURL=equipment-registry.js.map